import { Box } from '@mui/material';

function NavOptions({ isMenuOpen }) {
	return <Box sx={{ display: 'none' }} />;
}

export default NavOptions;
